import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CheckReservationUseCase } from '@/core/domain/check-reservation/usecases/checkReservation.usecase';
import { CheckReservationRepository } from '@/core/domain/check-reservation/repositories/check-reservation.repository';
import { CheckReservationImplRepository } from './check-reservation-impl.repository';

const checkReservationUseCaseFactory = (
    checkReservationRepository: CheckReservationRepository,
) => new CheckReservationUseCase(checkReservationRepository);

@NgModule({
    imports: [CommonModule],
    providers: [
        {
            provide: CheckReservationUseCase,
            useFactory: checkReservationUseCaseFactory,
            deps: [CheckReservationRepository],
        },
        {
            provide: CheckReservationRepository,
            useClass: CheckReservationImplRepository,
        },
    ],
})
export class CheckReservationDataModule {}
